/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CustomerPhoneSignupVariables = Types.Exact<{
  phoneToken: Types.Scalars['String']
  firstName: Types.Scalars['String']
  lastName: Types.Scalars['String']
  email: Types.Scalars['String']
}>

export type CustomerPhoneSignup = {
  __typename: 'Root'
  customerPhoneSignup: {
    __typename: 'CustomerPhoneSignupPayload'
    redirectTo: string | null
    customer: {
      __typename: 'Customer'
      id: number
      authenticationToken: string
      email: string
      completeProfile: boolean
      anonymous: boolean
      phone: any | null
      firstName: string | null
      lastName: string | null
    } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CustomerPhoneSignupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CustomerPhoneSignup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phoneToken' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstName' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastName' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerPhoneSignup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phoneToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phoneToken' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'firstName' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'lastName' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authenticationToken' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completeProfile' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymous' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CustomerPhoneSignupMutationFn = Apollo.MutationFunction<
  CustomerPhoneSignup,
  CustomerPhoneSignupVariables
>

/**
 * __useCustomerPhoneSignup__
 *
 * To run a mutation, you first call `useCustomerPhoneSignup` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerPhoneSignup` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerPhoneSignup, { data, loading, error }] = useCustomerPhoneSignup({
 *   variables: {
 *      phoneToken: // value for 'phoneToken'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCustomerPhoneSignup(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CustomerPhoneSignup,
    CustomerPhoneSignupVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CustomerPhoneSignup,
    CustomerPhoneSignupVariables
  >(CustomerPhoneSignupDocument, options)
}
export type CustomerPhoneSignupHookResult = ReturnType<
  typeof useCustomerPhoneSignup
>
export type CustomerPhoneSignupMutationResult =
  Apollo.MutationResult<CustomerPhoneSignup>
export type CustomerPhoneSignupMutationOptions = Apollo.BaseMutationOptions<
  CustomerPhoneSignup,
  CustomerPhoneSignupVariables
>
